import { render, staticRenderFns } from "./rproducts.vue?vue&type=template&id=40d8aa24"
import script from "./rproducts.vue?vue&type=script&lang=ts"
export * from "./rproducts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports